import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  AiReportDialogComponent,
  AiReportDialogData,
} from 'src/app/components/ai-reports/ai-report-dialog/ai-report-dialog.component';

@Injectable({ providedIn: 'root' })
export class AiReportDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: AiReportDialogData): MatDialogRef<AiReportDialogComponent> {
    return this.dialog.open(AiReportDialogComponent, {
      data,
      width: '1100px',
      maxWidth: '96vw',
      height: '88vh',
      panelClass: 'ai-report-dialog-panel',
      autoFocus: false,
    });
  }
}
